import { UrlType } from './constants';
import fly from './http';
function handleToken(urlType) {
  var _fly$config, _fly$config$extra;
  var accessToken = (_fly$config = fly.config) === null || _fly$config === void 0 ? void 0 : (_fly$config$extra = _fly$config.extra) === null || _fly$config$extra === void 0 ? void 0 : _fly$config$extra.accessToken;
  var opts = {
    headers: {
      urlType: urlType
    }
  };
  if (!!accessToken) {
    opts.headers['SUB-Access-Token'] = accessToken;
  }
  return opts;
}

/**
 * **接口** [payNow二维码扫码支付、返回二维码供前端扫码↗](https://apidoc.inshopline.com/#/project/Java/259/feature%2FDY-548_addPayPhone/interface/85097a7a6a420361e8e1efad63989d98)
 * @请求头 `POST /api/bill/platform/pay/payNow`
 * @更新时间 `2023-06-15 19:34:06`
 */
export function postPayPayNow(payload) {
  var opts = handleToken(UrlType.BILL);
  return fly.post("/pay/payNow", payload, opts);
}